import script from "./FixfloSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./FixfloSelector.vue?vue&type=script&lang=ts&setup=true"

import "./FixfloSelector.vue?vue&type=style&index=0&id=4ce1bf06&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ce1bf06"]])

export default __exports__